import React from "react"
import { LazyLoadImage } from "react-lazy-load-image-component"
import { useSelector } from "react-redux"

import { resolveStorageUrl } from "utils"

const LazyImage = (props) => {
  const {
    src,
    imageWidth,
    quality = 100,
    lazy = true,
    ...otherProps
  } = props

  const source = src === "/" ? "" : resolveStorageUrl(src)

  const serviceTypeName =
    useSelector(state =>
      state.systemSettings.serviceTypeName
    )

  const imageSrc =
    source
      ?
      imageWidth
        ? `${source}${source.includes("?") ? "&" : "?"}width=${imageWidth}&quality=${quality}`
        : source
      :
      serviceTypeName === "restaurant"
        ? "/assets/images/food-image-placeholder.png"
        : "/assets/images/product-image-placeholder.png"

  const Component = lazy ? LazyLoadImage : "img"

  return (
    <Component
      src={imageSrc}
      {...otherProps}
    />
  )
}

export default LazyImage
